import { type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';
import { inMemoryCache } from '../../../utils/caching/in-memory';

const spacesCache = inMemoryCache<AggResponse<ConfluenceSpaceKeysToIdsQueryResponse>>();

const GRAPHQL_OPERATION_NAME = 'ConfluenceSpaceKeysToIdsQuery';

const CONFLUENCE_SPACE_KEYS_TO_IDS_QUERY = `
query ${GRAPHQL_OPERATION_NAME}($cloudId: ID!, $spaceKeys: [String]) {
  spaces(cloudId: $cloudId, spaceKeys: $spaceKeys) {
    nodes {
      id
    }
  }
}
`;

export interface ConfluenceSpaceKeysToIdsQueryResponseNode {
	id: string | null;
}

export interface ConfluenceSpaceKeysToIdsQueryResponseNodes {
	nodes: (ConfluenceSpaceKeysToIdsQueryResponseNode | null)[] | null;
}

export interface ConfluenceSpaceKeysToIdsQueryResponse {
	spaces: ConfluenceSpaceKeysToIdsQueryResponseNodes | null;
}

export interface ConfluenceSpaceKeysToIdsQueryVariables {
	/** AGG has no `cloudId` in the endpoint path, so it is sent as a query variable. */
	cloudId: string;
	spaceKeys?: (string | null)[] | null;
}

export interface ConfluenceSpaceKeysToIdsQueryProps {
	spaceKeys: string[];
	cloudId: string;
	headers?: Record<string, string>;
}

export const confluenceSpaceKeysToIdsQuery = ({
	spaceKeys,
	cloudId,
	headers,
}: ConfluenceSpaceKeysToIdsQueryProps): Promise<
	AggResponse<ConfluenceSpaceKeysToIdsQueryResponse>
> => {
	return spacesCache.inMemoryDecorator(`${spaceKeys.join(',')}-${cloudId}`, async () => {
		const response = await fetchAgg<
			ConfluenceSpaceKeysToIdsQueryVariables,
			ConfluenceSpaceKeysToIdsQueryResponse
		>({
			graphQuery: CONFLUENCE_SPACE_KEYS_TO_IDS_QUERY,
			variables: { cloudId, spaceKeys },
			operationName: GRAPHQL_OPERATION_NAME,
			headers,
		});

		const hasErrors = response.errors?.some((error) => error);
		if (hasErrors) {
			return Promise.reject(response);
		}
		return response;
	});
};
